import {Routes} from "@angular/router";

import {inject} from "@angular/core";
import {UserService} from "./app/service/user.service";

export const ROUTES: Routes = [
  {
    path: '',
    loadComponent: () => import('./app/components/common/home/home.component').then(m => m.HomeComponent)
  },
  {
    path: 'application',
    loadChildren: () => import('./app/components/application/routes').then(m => m.APPLICATION_ROUTES),
    canActivate: [() => inject(UserService).isAuthenticated()]
  },
  {
    path: 'admin',
    loadChildren: () => import('./app/components/admin/routes').then(m => m.ADMIN_ROUTES),
    canActivate: [() => inject(UserService).hasAnyRole('ROLE_SUPER_ADMIN','ROLE_ADMIN')]
  },
];
